import React from 'react';
import { scrollTo } from '../../utils/scrollTo';
import logo from '../../assets/logo.svg';
import './Footer.css';

const NAV_ITEMS = ['home', 'about', 'solutions', 'contact'];

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">

        {/* Left — logo */}
        <div className="footer__left">
          <img src={logo} alt="Best World HealthNextlogo" className="footer__logo" />
        </div>

        {/* Right — copy + nav links */}
        <div className="footer__right">
          <nav className="footer__links" aria-label="Footer navigation">
            {NAV_ITEMS.map((id) => (
              <a
                key={id}
                href={`#${id}`}
                onClick={(e) => { e.preventDefault(); scrollTo(id); }}
              >
                {id.charAt(0).toUpperCase() + id.slice(1)}
              </a>
            ))}
          </nav>
          <p className="footer__copy">
            &copy; 2026 Best World HealthNext. Strategic Healthcare Excellence.
          </p>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
